import { Controller } from "@hotwired/stimulus"

// 취급량 무시 체크 시 최대취급량 행을 disable/enable
export default class extends Controller {
  static targets = ["row"]
  static values = { disabled: { type: Boolean, default: false } }

  connect() {
    this.applyState(this.disabledValue)
  }

  toggle(event) {
    this.applyState(event.target.checked)
  }

  applyState(disabled) {
    this.rowTargets.forEach(row => {
      row.querySelectorAll("input, select").forEach(el => {
        el.disabled = disabled
      })
      // Fomantic UI dropdown disable
      row.querySelectorAll(".ui.dropdown").forEach(el => {
        if (disabled) {
          el.classList.add("disabled")
        } else {
          el.classList.remove("disabled")
        }
      })
      row.style.opacity = disabled ? "0.4" : "1"
      row.style.pointerEvents = disabled ? "none" : ""
    })
  }
}
